
export default class TextMultilineBoxRenderer
{


  constructor() {
    this.lines = {};
  }
  render(ctx, text, font, xStart, yStart, width, scaleFunc, maxLines, suffix)
  {

    let key = `${text}-${width}-${font.scale(1)}-${font.getSize(1)}`
    if(!this.lines[key]){
      this.lines[key] = this.calculateLines(ctx, text,font, width)
    }
    let box = this.lines[key];
    box.lines.forEach((line, i) => {
      if((i+1) === maxLines){
        ctx.fillText(
            line.substring(0,line.length - (suffix.length + 1)) + suffix,
            scaleFunc(xStart),
            scaleFunc(yStart + i * box.lineHeight + box.lineHeight * .7)
        );
      }
      if((i+1) < maxLines){
        ctx.fillText(
            line,
            scaleFunc(xStart),
            scaleFunc(yStart + i * box.lineHeight + box.lineHeight * .7)
        );
      }

    })
  }


  calculateLines(ctx, text,font, width) {

    if (!text && text.length <= 1) {
      return {width : 0, height: 0,lines:[],lineHeight:1};
    }

    ctx.font = font.scale(1);
    let lineHeight = font.getSize() * 1.5;

    let lines = this.fitText(ctx, text, width);
    let height = lineHeight * lines.length;

    return { width, height, lineHeight, lines};

  }

  fitText(ctx, text, maxWidth) {

    let lines = [];
    let words = text.split(/\s/g);
    let wordCount = words.length;
    let currentLine = [];

    for (let i = 0; i < wordCount; i++) {

      let word = words[i].trim();
      let removed = ''

      let currentLineString = currentLine.join(' ');
      let test = currentLineString + " " + word
      let size = ctx.measureText(test).width;

      let wordCutoff = false
      while (size > maxWidth && word.length > 3) {
        wordCutoff = true
        // Determine how much of the word will fit
        word = words[i].substring(0, word.length - 1)
        removed = words[i].substring(word.length)

        test = currentLineString + " " + word + "-"
        size = ctx.measureText(test).width;
      }

      if(wordCutoff){
        word += "-"
        if (removed) {
          words[i] = word
          words.splice(i + 1, 0, removed);
          wordCount++;
        }
        currentLine.push(word);
        lines.push(currentLine.join(" "));
        currentLine = []

      } else {
        if (size > maxWidth) {
          lines.push(currentLine.join(" "));
          currentLine = [];
        }
        currentLine.push(word);
      }

    }

    if (currentLine.length) {
      lines.push(currentLine.join(" "));
    }

    return lines;

  }



}
